<app-ncarb-silent-load [isVisible]="true"></app-ncarb-silent-load>
